import React, { ReactNode } from 'react';
import { Outlet } from 'react-router-dom';

import { useScreenSize } from '@hcs/hooks';

import { HEADER_HEIGHT_DESKTOP, HEADER_HEIGHT_PHONE } from '../Header';

import styles from './LayoutGlobalHeader.module.css';

export interface LayoutGlobalHeaderProps {
  type: 'outlet' | 'children';
  children?: ReactNode;
  header?: ReactNode;
  banner?: ReactNode;
}

export const LayoutGlobalHeader = ({
  type,
  header,
  banner,
  children,
}: LayoutGlobalHeaderProps) => {
  const { isPhoneWidth } = useScreenSize();
  const paddingTop = isPhoneWidth ? HEADER_HEIGHT_PHONE : HEADER_HEIGHT_DESKTOP;

  return (
    <>
      {header || null}
      <div
        className={styles.Layout}
        style={{
          paddingTop,
        }}
      >
        {banner}
        <div className={styles.Content}>
          {type === 'outlet' && <Outlet />}
          {children}
        </div>
      </div>
    </>
  );
};

export const LayoutGlobalHeaderOutlet = (
  props: Omit<LayoutGlobalHeaderProps, 'type'>,
) => {
  return <LayoutGlobalHeader type="outlet" {...props} />;
};

export const LayoutGlobalHeaderChildren = (
  props: Omit<LayoutGlobalHeaderProps, 'type'> & { children: ReactNode },
) => {
  return <LayoutGlobalHeader type="children" {...props} />;
};
